import script from "./TelegramWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramWrapper.vue?vue&type=script&setup=true&lang=js"

import "./TelegramWrapper.vue?vue&type=style&index=0&id=1057be85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1057be85"]])

export default __exports__